<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-list">
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="vx-col md:w-1/12">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ contacts.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : contacts.length }} of {{ contacts.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
        <div class="vx-col md:w-1/12">
          <b><vs-checkbox v-model="searchModel.status" @input="getUsers()">Aktif</vs-checkbox></b>
        </div>
        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Tüm Alanlarda Ara..." />
        <vs-button class="mb-4 md:mb-0 mr-4" @click="$router.push('../UserAdd')">Personel Ekle</vs-button>
      </div>

      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="contacts"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :rowClassRules="rowClassRules"
      ></ag-grid-vue>

      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import { repository } from "@/_services/repository.js";

// Cell Renderer
import CellRendererLink from "./cell-renderer/CellRendererLink.vue";
import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue";
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";

import { Validator } from "vee-validate";
const dict = {
  custom: {
    namesurname: {
      alpha_spaces: "Sadece alfabetik karakter girebilirsiniz.",
      required: "Ad soyad boş geçilemez.",
    },
    mailaddress: {
      required: "Mail adresi zorunludur !",
      email: "Mail adresiniz ornek@ornek.com şeklinde olmalıdır.",
    },
    telephone: {
      required: "Telefon zorunludur !",
      numeric: "Telefon numaranız sadece rakamlardan oluşabilir.",
    },
  },
};
Validator.localize("tr", dict);

export default {
  components: {
    AgGridVue,
    vSelect,
    CellRendererLink,
    CellRendererStatus,
    CellRendererActions,
  },
  data() {
    return {
      searchModel: { status: 1 },
      userModel: [
        {
          userName: null,
          userMail: null,
          userCategory: null,
          phone: null,
          master: null,
          status: null,
          userId: null,
          teamLead: null,
        },
      ],
      searchQuery: "",

      promptForAddNewPersonnel: false,
      team: [],
      contacts: [],
      gridApi: null,
      gridOptions: { rowHeight: 40 },
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      rowClassRules: {
        rowColorForNotWorkingPerson: (params) => {
          var personStatus = params.data.status;
          return personStatus == false;
        },
      } /* eslint-disable */,
      columnDefs: [
        {
          headerName: "ID",
          field: "userId",
          sort: "desc",
          width: 125,
          filter: true,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
        },
        {
          headerName: "Adı Soyadı",
          field: "userName",
          filter: true,
          width: 210,
          cellRendererFramework: "CellRendererLink",
        },
        {
          headerName: "Email",
          field: "email",
          filter: true,
          width: 225,
        },
        {
          headerName: "Departman",
          field: "departmentName",
          filter: true,
          width: 150,
        },
        {
          headerName: "Telefon",
          field: "phone",
          filter: true,
          width: 150,
        },
        {
          headerName: "İl",
          field: "city",
          filter: true,
          width: 150,
        },
        {
          headerName: "Bölge",
          field: "region",
          filter: true,
          width: 150,
        },

        {
          headerName: "Durumu",
          field: "status",
          filter: true,
          width: 150,
          cellRendererFramework: "CellRendererStatus",
          valueFormatter: statusFormatter,
        },
        {
          headerName: "İşlemler",
          field: "transactions",
          width: 150,
          cellRendererFramework: "CellRendererActions",
        },
      ] /* eslint-enable  */,
    };
  },

  computed: {
    validateForm() {
      return !this.errors.any() && this.userModel.userName != null && this.userModel.userMail != null && this.userModel.phone != null;
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 10;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
  },
  methods: {
    clearFields() {
      this.userModel.userName = null;
      this.userModel.userMail = null;
      this.userModel.phone = null;
      this.userModel.userTeam = null;
    },
    //bringing departments
    teamGet: async function() {
      this.team = await repository.getAll("User/teamGet").then((r) => r.list);
    },
    //registernewoersonnel
    setUser: async function(d) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          repository
            .postEntity("User/AddUser", {
              email: d.userMail,
              name: d.userName,
              phone: d.phone,
              iban: "string",
              userTeam: d.userCategory.teamID,
              teamLead: d.teamLead,
            })
            .then((r) => {
              if (r.isSuccessful) {
                this.getUsers();
                this.gridOptions.api.setRowData(this.gridOptions.rowData);
                this.$vs.notify({
                  color: "success",
                  title: `Başarılı`,
                  text: "Ekleme işlem tamamlandı.",
                });
              } else if (r.hasExceptionError) {
                this.$vs.notify({
                  color: "danger",
                  title: `${r.exceptionMessage}`,
                  text: "İşlem tamamlanamadı.",
                });
              } else {
                this.$vs.notify({
                  color: "danger",
                  title: `Hata`,
                  text: "İşlem tamamlanamadı.Bilinmeyen Hata!",
                });
              }
              this.clearFields();
            });
        }
      });
    },
    //fetchusers
    getUsers: async function() {
      this.$vs.loading();
      this.contacts = await repository.postEntity("HumanResource/getUser", this.searchModel).then((r) => r.list);
      this.$vs.loading.close();
    },

    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
  },
  beforeUpdate() {
    this.gridApi.sizeColumnsToFit();
  },
  mounted() {
    this.gridApi = this.gridOptions.api;

    this.gridApi.sizeColumnsToFit();
  },
  created() {
    this.getUsers().catch((err) => {
      console.error(err);
    });
    this.teamGet().catch((err) => {
      console.error(err);
    });
  },
};
window.statusFormatter = function statusFormatter(params) {
  if (params.value == true) return "Çalışıyor";
  if (params.value == false) return "Ayrıldı";
};
</script>

<style lang="scss" scoped>
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
.rowColorForNotWorkingPerson {
  background-color: rgb(255, 235, 235) !important;
}
#vs1__listbox {
  height: 150px;
}
</style>
